'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { preloadResponsiveImage } from '@/app/components/media/app-image';
import { getSpartanProductExteriorThreesixtyPresetThumbnailSources } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/preset-thumbnails/sources';
interface SpartanProductExteriorThreesixtyPresetThumbnailPreloadsProps {
  frames: string[];
  indexes: readonly number[];
  enabled?: boolean;
}
export const SpartanProductExteriorThreesixtyPresetThumbnailPreloads = t0 => {
  const $ = _c(5);
  const {
    frames,
    indexes,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== enabled || $[1] !== frames || $[2] !== indexes) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      indexes.forEach(frameIndex => {
        const src = frames[frameIndex];
        if (!src) {
          return;
        }
        const {
          mobileSrc,
          desktopSrc
        } = getSpartanProductExteriorThreesixtyPresetThumbnailSources(src);
        preloadResponsiveImage(mobileSrc);
        preloadResponsiveImage(desktopSrc);
      });
    };
    t3 = [enabled, frames, indexes];
    $[0] = enabled;
    $[1] = frames;
    $[2] = indexes;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  return null;
};